export default "---\ntitle: Release Notes\nhide_title: false\nunlisted: true\n---\n\n## 1.0.0\n\n- Initial release of Curri Eclipse Integration\n"